<template>
    <div v-if="field">
        <div class="form-actions">
            <b-button variant="primary" @click="editor.show = true">{{ $t('edit') }}</b-button>
        </div>

        <b-modal title="Edit constraints" v-model="editor.show" @ok="save" @hide="hideConstraints" ok-only>
            <b-form-group
                v-if="canDisplayRequired"
                  :label="this.$t('required')"
                  label-for="required"
                  :label-cols="3"
                  :horizontal="false">
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.required"/>
            </b-form-group>

            <b-form-group
                :label="this.$t('unique')"
                :description="this.$t('uniqueField')"
                label-for="unique"
                :label-cols="3"
                :horizontal="false">
            <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.unique"/>
            </b-form-group>

            <b-form-group
                v-if="canDisplayPlaceholder"
                  :label="this.$t('placeholder')"
                  label-for="required"
                  :label-cols="3"
                  :horizontal="false">
            <b-form-input type="text" v-model="constraints.placeholder"></b-form-input>
            </b-form-group>

            <b-form-group
                v-if="canDisplayDefault"
                  :label="this.$t('default')"
                  label-for="required"
                  :label-cols="3"
                  :horizontal="false">
            <b-form-input type="text" v-model="constraints.default"></b-form-input>
            </b-form-group>

            <div v-if="field.module == 'input' && field.type == 'number'">
                <InputField :labelCols="3" name="min_length" type="number" :label="this.$t('minlength')" v-model.number="constraints.length.min" :rules="{}" @error="fieldError"/>

                <InputField :labelCols="3" name="max_length" type="number" :label="this.$t('maxLength')" v-model.number="constraints.length.max" :rules="{}" @error="fieldError"/>
            </div>
            <!-- DISPLAY THIS IF MODULE IS INPUT AND TYPE STRING -->
            <div v-if="(field.module == 'input' && (field.type == 'text' || field.type == 'password'))">
                <InputField :labelCols="3" name="min_length" type="number" :label="this.$t('minlength')" v-model.number="constraints.length.min" :rules="{required: true, length: {min:0, max: 99999}}" @error="fieldError"/>

                <InputField :labelCols="3" name="max_length" type="number" :label="this.$t('maxLength')" v-model.number="constraints.length.max" :rules="{required: true, length: {min:0, max: 99999}}" @error="fieldError"/>

                <b-form-group
                    :description="this.$t('notAllowedChars')"
                    :label="this.$t('notAllowedStrings')"
                    label-for="not_allowed_words"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="text" v-model="constraints.not_allowed_words"></b-form-input>
                </b-form-group>

                <b-form-group
                    :description="this.$t('validationRegex')"
                    :label="this.$t('regex')"
                    label-for="regex"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="text" v-model="constraints.regex"></b-form-input>
                </b-form-group>
            </div>
            <!-- DISPLAY THIS IF MODULE IS INPUT AND TYPE STRING -->

            <div v-if="field.module == 'input'">
                <ImageConstraints v-model="constraints" v-if="field.type == 'image'"/>
                <FileConstraints v-model="constraints" v-if="field.type == 'file'"/>
                <Texti18nConstraints v-model="constraints" v-if="field.type == 'text_i18n'"/>
            </div>

            <!-- DISPLAY THIS IF MODULE IS INPUT AND TYPE STRING -->
            <div v-if="(field.module == 'text')">
                <InputField :labelCols="3" name="min_length" type="number" :label="this.$t('minLength')" v-model.number="constraints.length.min" :rules="{required: false}" @error="fieldError"/>

                <InputField :labelCols="3" name="max_length" type="number" :label="this.$t('maxLength')" v-model.number="constraints.length.max" :rules="{required: false}" @error="fieldError"/>

                <b-form-group
                    :description="this.$t('notAllowedChars')"
                    :label="this.$t('notAllowedWords')"
                    label-for="not_allowed_words"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="text" v-model="constraints.not_allowed_words"></b-form-input>
                </b-form-group>

                <b-form-group
                    :description="this.$t('validationRegex')"
                    :label="this.$t('regex')"
                    label-for="regex"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="text" v-model="constraints.regex"></b-form-input>
                </b-form-group>
            </div>
            <!-- DISPLAY THIS IF MODULE IS INPUT AND TYPE STRING -->

            <div v-if="field.module == 'picker'">
                <DateConstraints v-model="constraints" v-if="field.type == 'date'"/>
                <PickerTimeConstraints v-model="constraints" v-if="field.type == 'time'" @error="fieldError"/>
                <DateTimeConstraints v-model="constraints" v-if="field.type == 'datetime'" @error="fieldError"/>
            </div>

            <div v-if="field.module == 'select'">
                <SelectTextConstraints v-model="constraints" v-if="field.type == 'text'"/>
                <SelectNumberConstraints v-model="constraints" v-if="field.type == 'number'"/>
                <SelectRelationConstraints v-model="constraints" :field="field" v-if="field.type == 'relation'"/>
                <SelectExternalConstraints v-model="constraints" :field="field" v-if="field.type == 'external'"/>
            </div>

            <div v-if="field.module == 'checkbox'">
                <CheckboxTextConstraints v-model="constraints" v-if="field.type == 'text'"/>
                <CheckboxNumberConstraints v-model="constraints" v-if="field.type == 'number'"/>
            </div>

            <div v-if="field.module == 'radio'">
                <RadioTextConstraints v-model="constraints" v-if="field.type == 'text'"/>
                <RadioNumberConstraints v-model="constraints" v-if="field.type == 'number'"/>
            </div>

            <div v-if="field.module == 'table' && field.type == 'custom'">
                <TableCustomConstraints v-model="constraints"/>
                <TableCustomFields v-model="constraints"/>
            </div>

            <div v-if="field.module == 'image' && field.type == 'carousel'">
                <ImageCarousel v-model="constraints" />
            </div>

            <div v-if="field.module == 'fieldset'">
                <DefaultFieldsetConstraints v-model="constraints" v-if="field.type == 'default'"/>
            </div>

            <div v-if="field.module == 'data'">
                <DataJsonConstraints v-model="constraints" v-if="field.type == 'json'"/>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import Input from '@/components/form/Input'
import CodeEditor from '@/components/form/Editor/Code'

export default {
    components: {
        cSwitch,
        InputField: Input,
        CodeEditor,
        DateConstraints: () => import('../../identityFields/constraints/picker/Date'),
        SelectTextConstraints: () => import('../../identityFields/constraints/select/Text'),
        SelectNumberConstraints: () => import('../../identityFields/constraints/select/Number'),
        SelectExternalConstraints:() => import('../../identityFields/constraints/select/External'),
        CheckboxTextConstraints:() => import('../../identityFields/constraints/checkbox/Number'),
        RadioTextConstraints:() => import('../../identityFields/constraints/radio/Text'),
        RadioNumberConstraints:() => import('../../identityFields/constraints/radio/Number'),
        SelectRelationConstraints:() => import('../../identityFields/constraints/select/Relation'),
        TableCustomConstraints: () => import('../../identityFields/constraints/table/Custom'),
        TableCustomFields: () => import('../../identityFields/constraints/table/Fields'),
        PickerTimeConstraints: () => import('../../identityFields/constraints/picker/Time'),
        DateTimeConstraints: () => import('../../identityFields/constraints/picker/DateTime'),
        ImageCarousel: () => import("../../identityFields/constraints/image/Carousel"),
        ImageConstraints: () => import("../../identityFields/constraints/input/Image"),
        FileConstraints: () => import("../../identityFields/constraints/input/File"),
        DefaultFieldsetConstraints: () => import("../../identityFields/constraints/fieldset/Default"),
        DataJsonConstraints: () => import("../../identityFields/constraints/data/Json"),
        Texti18nConstraints: () => import("../../identityFields/constraints/input/Texti18n")
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Object
        }
    },
    watch: {
        "constraints.length.min": function(nval, oval) {
            if (nval == "" || nval === null || nval === undefined) {
                this.constraints.length.min = 0;
            }

            if (nval > this.constraints.length.max) {
                this.constraints.length.max = nval
            }
        },

        "constraints.length.max": function(nval, oval) {
            if (nval == "" || nval === null || nval === undefined) {
                this.constraints.length.max = 0;
            }

            if (nval < this.constraints.length.min) {
                this.constraints.length.min = nval
            }
        }
    },
    data: function() {
        return {
            errors: [],
            editor: {
                show: false
            }
        }
    },
    computed: {
        canDisplayRequired() {
            return (this.field.module != "table")
        },

        canDisplayPlaceholder() {
            return (
                this.field.module != "table" &&
                this.field.module != "checkbox" &&
                this.field.module != "radio" &&
                this.field.type != "relation"
                )
        },

        canDisplayDefault() {
            return (
                this.field.module != "table" &&
                this.field.module != "checkbox" &&
                this.field.module != "radio" &&
                this.field.type != "relation"
                )
        },

        constraints: {
            get() {
                return this.value;
            },

            set(val) {
                console.log("field constraints set", val)
                this.$emit('input', val);
            }
        }
    },
    methods: {
        save(modal) {
            if (this.checkForErrors()) {
                modal.preventDefault()
                this.$bvModal.msgBoxOk("Some fields are not valid!")

                return
            }

            this.$emit('input', this.constraints)
        },

        hideConstraints(modal) {
            if (modal.trigger != "ok")
                this.save(modal)
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },
    }
}
</script>
